import React, { useContext } from 'react';
import { Accordion, AccordionContext, Card } from 'react-bootstrap';

const Caret = ({ eventKey }) => {
  const currentEventKey = useContext(AccordionContext);

  const isActive = currentEventKey === eventKey;

  return <i className={`fa fa-fw fa-caret-${isActive ? 'down' : 'right'}`}></i>;
};

export default ({ children, title, active = false }) => {
  return (
    <Accordion defaultActiveKey={active}>
      <Card>
        <Accordion.Toggle as={Card.Header} className="accordionHeader" eventKey="0">
          <Caret eventKey="0" />
          &nbsp; {title}
        </Accordion.Toggle>
        <Accordion.Collapse eventKey="0">
          <Card.Body>{children}</Card.Body>
        </Accordion.Collapse>
      </Card>
    </Accordion>
  );
};
